import type { FirestoreError } from 'firebase/firestore';
import type { Invoice } from '@altyor-kronos/shared-types';
import { usePolledResource } from '../../core/data/usePolledResource';
import { apiList } from '../../core/data/restClient';

export interface ProjectInvoicesState {
  rows: Array<{ id: string; data: Invoice }>;
  loading: boolean;
  error: FirestoreError | null;
}

/**
 * Read a project's invoices subcollection — gated by `enabled` since
 * invoice READ is restricted (finance / direction / admin / project
 * manager per firestore.rules) and `FinanceTable` only wants a read for
 * roles the rule actually allows.
 */
export function useProjectInvoices(projectId: string, enabled: boolean): ProjectInvoicesState {
  const { rows, loading, error } = usePolledResource<Invoice & { id: string }>(
    enabled && projectId ? projectId : null,
    () => apiList<Invoice & { id: string }>(`/projects/${projectId}/invoices`),
  );
  return {
    rows: rows.map((r) => ({ id: r.id, data: r })),
    loading,
    error: error as FirestoreError | null,
  };
}
